var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 62,
    viewBox: "0 0 122 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25060_139772)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6888 34.9551L28.2225 13.9839C24.129 4.69173 18.4151 1.19653 0.505859 1.19653C7.07257 2.90151 11.422 6.31146 15.0038 13.9839L36.239 60.8707C36.303 60.7522 36.3677 60.6327 36.4329 60.5121C39.3256 55.1663 43.3601 47.7104 37.6888 34.9551ZM67.7934 34.9551L58.327 13.9839C54.9158 6.31146 57.9859 2.90151 63.2734 1.19653H30.6104C37.1771 2.90151 41.5265 6.31146 45.1083 13.9839L66.3436 60.8707C66.4075 60.7522 66.4722 60.6327 66.5374 60.5121C69.4301 55.1663 73.4646 47.7104 67.7934 34.9551ZM98.3232 25.8334C86.3837 19.0988 77.0027 13.0461 82.2902 1.19653C75.2118 1.19653 70.8624 6.22621 70.8624 12.8756C70.8624 21.9972 76.491 27.4532 88.9422 34.3583C107.875 44.9292 112.992 49.7031 105.828 60.8707C113.93 60.8707 120.497 55.7558 120.497 47.2309C120.497 37.989 113.131 33.96 102.901 28.3647L102.9 28.3642L102.899 28.3639C101.429 27.5595 99.8988 26.7227 98.3232 25.8334ZM116.232 1.19653H103.44C111.116 3.754 113.674 6.31146 116.232 13.9839V1.19653ZM74.547 60.6287L74.6126 60.6275C74.5908 60.6282 74.569 60.6286 74.547 60.6287ZM74.6126 60.6275C76.6751 60.5887 80.4312 60.602 84.1875 60.6153C86.0565 60.6219 87.9256 60.6285 89.5862 60.6287C83.0809 58.6257 82.226 56.668 79.6598 50.7917C79.2715 49.9026 78.8441 48.9237 78.3519 47.8414C78.3519 47.8414 79.0937 60.4801 74.6126 60.6275Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25060_139772"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7.11111C0 3.18375 3.18375 0 7.11111 0H114.889C118.816 0 122 3.18375 122 7.11111V54.8889C122 58.8162 118.816 62 114.889 62H7.11111C3.18375 62 0 58.8162 0 54.8889V7.11111Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWs);
export default __webpack_public_path__ + "static/media/ws.5d4b311f4fe0f7684217cf9f44d5a4a5.svg";
export { ForwardRef as ReactComponent };